app.service('searchService', ['$rootScope', '$timeout', '$filter', function ($rootScope, $timeout, $filter) {

    var that = this;

    /**
     * Remplace le message par défaut de semantic ui
     * @param {String} message Message remplaçant celui par defaut
     */
    var newHeader = function (message)
    {
        var html = '';
        if (message !== undefined) {
            html += '' + '<div class="message">';
            html += '' + '<div class="header">'+$filter('translate')('erreur')+'</div class="header">' + '<div class="description">' + message + '</div class="description">';
            html += '</div>';
        }
        return html;
    };
    $.fn.search.settings.templates.message = newHeader;

    /**
     * Options par défaut de l'input search
     * https://semantic-ui.com/modules/search.html#/settings
     */
    this.defaultOptions = {
        minCharacters : 1,
        maxResults: -1,
        transition: 'slide down',
        duration: 500,
        searchDelay: 750,
        error: {
            noResults: 'Aucun résultat.',
            serverError : 'Une erreur s\'est produite lors de la recherche.'
        },
        apiSettings: {
            url: ''
        }
    };

    /**
     * Initialise l'option onResultClose
     * @param {String} searchInputID ID de l'input search
     */
    this.setDefaultOptionsOnResultClose = function(searchInputID) {
        that.defaultOptions.onResultsClose = function() {
            // Reset si valeur vide
            if($('.ui.search #'+searchInputID).val() == '') {
                $('.ui.search #'+searchInputID).attr('placeholder', 'Recherche');
            }
        }
    }

    /**
     * Fonction permettant de fusionner les options par défaut avec les options de l'utilisateur
     */
    this.setOptions = function() {
        var extendedKeys = [];
        angular.forEach(Object.keys(that.defaultOptions), function(key) { // Pour chaque clé des options par défaut
            if(key in that.userOptions && typeof that.defaultOptions[key] === 'object') { // Si cette clé est présente dans les options utilisateur et que c'est un objet
                $.extend(that.defaultOptions[key], that.userOptions[key]); // Fusion de la clé
                extendedKeys.push(key); // Push dans le tableau répertoriant les clés déjà traitées
            }
        });

        angular.forEach(Object.keys(that.userOptions), function(key) { // Pour chaque clé des option utilisateur
            if(extendedKeys.indexOf(key) === -1) { // Si cette clé n'a pas été traitée précédemment
                that.defaultOptions[key] = that.userOptions[key]; // Remplacement de cette clé dans les options par défaut
            }
        });
        return that.defaultOptions;
    };

    return {
        init: function(searchDivID, searchInputID, url, userOptions) {  // Initialisation de l'input search
            // Variables servants aux options
            that.defaultOptions.apiSettings.url = url+'?searchValue={query}';
            that.userOptions                    = (userOptions === undefined || userOptions === null || typeof userOptions !== 'object') ? {} : userOptions; // Formattage des options utilisateurs
            that.searchDivID                    = searchDivID; // Div contenant l'input search

            that.setDefaultOptionsOnResultClose(searchInputID); // Init option onresultclose

            $('#'+searchDivID).search(that.setOptions()); // Activation de l'input
		}
	};
}]);
